// Copyright (c) 2019 Deere & Company

export const ComponentCodeColumnDefinitions = [
    {

        field: 'componentFactoryCode',
        headerName: 'Component Factory',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,

    },
    {

        field: 'componentPartNumber',
        headerName: 'Component Part Number',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,

    },
    {

        field: 'manufacturingFactoryCode',
        headerName: 'Manufacturing Factory',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,

    },
    {

        field: 'model',
        headerName: 'Model Code',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,

    },
    {

        field: 'componentFunctionCodeName',
        headerName: 'Component Function Code',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,

    },
    {

        field: 'componentGroupCode',
        headerName: 'Component Group Code',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,

    },
];
